import {AfterViewInit, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, TemplateRef, ViewChild} from '@angular/core';
import {Compbaser} from "../compbaser";
import {StoreSelectorsService} from "../../services";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {MatAccordion} from '@angular/material/expansion';
import {TwitterService} from "../../services/twitter-service";

enum SourceType { "profile", "list", "collection", "likes" }

export class TimelineSource {
    sourceType: SourceType | string;
    screenName?: string;
    ownerScreenName?: string;
    slug?: string;
    url?: string;
}

enum ChromeOptions { "noheader", "nofooter", "noborders", "transparent", "noscrollbar" }

enum ThemeOptions { "dark", "light" }

enum AreaPoliteOptions { "polite", "assertive", "rude" }

class TimelineOptions {
    chrome?: string[] | ChromeOptions[];
    width?: string | any;
    height?: string | any;
    tweetLimit?: number;
    borderColor?: string;
    theme?: ThemeOptions | string;
    ariaPolite?: string[] | AreaPoliteOptions[];
    dnt?: boolean;
}

@Component({
    selector: 'app-twitter',
    styleUrls: [`./twitter.component.scss`],
    templateUrl: './twitter.component.html',
    // animations: [
    //     trigger(
    //         'inOutAnimation',
    //         [
    //             transition(
    //                 ':enter',
    //                 [
    //                     style({height: 0, opacity: 0}),
    //                     animate('1s ease-out',
    //                         style({height: 150, opacity: 1}))
    //                 ]
    //             ),
    //             transition(
    //                 ':leave',
    //                 [
    //                     style({height: 150, opacity: 1}),
    //                     animate('1s ease-in',
    //                         style({height: 0, opacity: 0}))
    //                 ]
    //             )
    //         ]
    //     ),
    //     trigger("grow", [ // Note the trigger name
    //         transition(":enter", [
    //             style({height: "0", overflow: "hidden"}),
    //             animate(500, style({height: "*"}))
    //         ]),
    //         transition(":leave", [
    //             animate(500, style({height: 0, overflow: "hidden"}))
    //         ])
    //     ])]
})

export class TwitterComponent extends Compbaser implements AfterViewInit, OnInit {
    @Input() source: TimelineSource | object = {screenName: 'mediasignage', url: 'https://twitter.com/mediasignage.com'};
    @Input() options: TimelineOptions | object = {height: '400', width: '600', tweetLimit: 100, theme: ThemeOptions.light, chrome: [0, 0, 0]};
    @Output() onLoad: EventEmitter<any> = new EventEmitter();

    @ViewChild("networkStatusModal", {read: TemplateRef}) networkStatusModal: TemplateRef<any>;
    @ViewChild(MatAccordion) accordion: MatAccordion;

    loading = true;

    private scriptAttr: string | any = "twttr";

    constructor(
        @Optional() @Inject(MAT_DIALOG_DATA) data,
        private storeSelector: StoreSelectorsService,
        private element: ElementRef,
        private twitterService: TwitterService) {
        super();
    }

    ngOnInit(): void {
    }

    async ngAfterViewInit() {
        await this.loadScript();
        await this.loadWidget();
    }

    private async loadWidget() {
        await this.twitterService.loadElement(
            "createTimeline",
            this.getObj(this.source), this.element, this.options, (response: object) => {
                this.loading = false;
                this.onLoad.emit(response);
            }
        );
    }

    private getObj(value: any) {
        return typeof value === "object" ? {...value} : value;
    }

    private async loadScript() {
        return new Promise((resolve, reject) => {
            this.twitterService.load(this.scriptAttr)
                .then(data => {
                    resolve(true);
                    console.log("Script loaded successfully,");
                })
                .catch(err => {
                    reject();
                    console.log("Script load issue,");
                });
        });
    }
}
